import { render } from "./GeolocationApiSettings.vue?vue&type=template&id=509cb0e0"
import script from "./GeolocationApiSettings.vue?vue&type=script&lang=js"
export * from "./GeolocationApiSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__